module.exports = __webpack_public_path__ + "img/pic.fdde8475.svg";